module.exports = __webpack_public_path__ + "static/img/zug.6ca9bb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zug.jpg
// module id = D58w
// module chunks = 1